import { authenticatorApi } from "@/infrastructure/api/authenticatorApi";

export async function getImageContent(source: string, signal?: AbortSignal) {
  const { data } = await authenticatorApi.get<Blob>(
    "/negocios/imagens/conteudo",
    {
      params: { source },
      responseType: "blob",
      signal,
    },
  );

  return data;
}
